import { Injectable } from '@angular/core';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { Observable } from 'rxjs';
import { IResponseInfo } from '../http/http.data';
import { map } from 'rxjs/operators';
import { UnmatchedPaymentsWithClients } from './models/unmatched-payments-with-clients.model';
import { UnmatchedPayment } from './models/unmatched-payment.model';
import { Document } from '../document-data/document.model';

export const UNMATCHED_PAYMENTS_LIST_URL = '/payments/transactions/unmatched';

@Injectable()
export class InvoiceMatchPaymentsDataService {
  constructor(private _authHttpService: AuthHttpService) {}

  fetchUnmatchedPayments(): Observable<UnmatchedPaymentsWithClients> {
    return this._authHttpService
      .get(UNMATCHED_PAYMENTS_LIST_URL, {
        return_clients: true,
      })
      .pipe(
        map(({ body }: IResponseInfo) => new UnmatchedPaymentsWithClients(body))
      );
  }

  matchPayment(
    document: Document,
    payment: UnmatchedPayment,
    amountToMatch: number
  ): Observable<UnmatchedPaymentsWithClients> {
    return this._authHttpService
      .post(
        `payments/transactions/${payment.transactionGuid}/match?return_clients=true`,
        {
          document_id: document.id,
          revision_id: document.revisionId,
          unmatched_amount: payment.unmatchedAmount,
          amount_to_match: amountToMatch,
        }
      )
      .pipe(
        map(({ body }: IResponseInfo) => new UnmatchedPaymentsWithClients(body))
      );
  }
}
